import { render, staticRenderFns } from "./NsimAdd.vue?vue&type=template&id=3c974bd2"
import script from "./NsimAdd.vue?vue&type=script&lang=js"
export * from "./NsimAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports